import React from 'react';

import * as styles from './MarketoForm.module.scss';

const FormContainer = ({ className, formId, fade, isNewDemo }) => {
  return (
    <>
      <form
        data-analytics-component={'marketo-embedded-form'}
        data-analytics-id={formId}
        noValidate={true}
        className={[className, 'marketo-form', fade, isNewDemo ? styles.isNewDemo : ''].join(' ')}
        id={`mktoForm_${formId}`}
        data-component={'marketo-form'}
      ></form>
      <link id="mktoOverride" rel="stylesheet" href="/mktoOverrides.css" />
    </>
  );
};

export default FormContainer;
